<template>
  <div style="background-color: #FBF6F3;height: 100%">
    <v-layout>
      <v-flex>
        <v-layout>
          <v-flex style="padding: 2% 5% 2% 5%">
            <v-card flat class="pb-8">
              <!-- Header -->
              <v-layout
                  mb-12
                  pa-8
                  justify-center
                  style="background-color: #3E7662;"
              >
                <v-flex style="text-align: left;">
                  <span style="font-weight: bold;font-size: 28px;color: white;"
                  >แบบฟอร์มลงประเมิน</span
                  >
                </v-flex>
              </v-layout>

              <!-- Form Register -->
              <v-layout justify-center>
                <v-flex xs12 sm10 md8 lg10 pt-8 pb-12>
                  <v-layout>
                      <v-flex>
                        <textarea-form
                            placeholder="ข้อคิดเห็นจากอนุกรรมการ"
                            background-color="#FBF6F3"
                            :rows="7"
                            :model="form.comment"
                            @update-data="
                      updateData('comment', $event)
                    "
                        ></textarea-form>
                      </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                        shrink
                        pt-2
                        pr-4
                        style="text-align: left;"
                        class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;">ไฟล์</span>
                    </v-flex>
                    <v-flex xs3>
                      <v-file-input
                          accept=".doc"
                          prepend-icon=""
                          outlined
                          id="file"
                          dense
                          placeholder="Choose file"
                          color="#3E7662"
                          item-color="#3E7662"
                          hide-details
                          @change="onUploadFile('file',$event)"
                      ></v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                          color="#3E7662"
                          dark
                          @click="onHandleBtn('file')"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex mb-12 style="padding: 0 5% 2% 5%; text-align: right;">
            <v-layout>
              <v-flex>
                <v-btn
                    depressed
                    dark
                    color="#3E7662"
                    @click="save"
                >บันทึก</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
        color="#527281"
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
    ></loading>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import TextareaForm from "../../components/input/TextareaForm";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-select/dist/vue-select.css";

export default {
  name: "Review",
  components: {
    TextareaForm,
    Loading,
  },
  data: () => ({
    isLoadingUpload: false,
    isLoading: false,
    form: {
      comment:"",
      file:"",
      index:"",
      reviewerIndex:"",
      meetingID:""
    },
  }),
  async created() {
    this.form.index = this.$route.query.index;
    this.form.reviewerIndex = this.$route.query.reviewerIndex;
    this.form.meetingID = this.$route.query.meetingID;
  },
  methods: {
    getUser() {
      this.isLoading = true;
      this.$store
          .dispatch("User/getUserById", this.$route.query.id)
          .then((res) => {
            console.log(res);
            this.form.nameTitleID = res.title_name.id;
            this.form.gender = res.gender ? res.gender.toString() : '';
            this.form.rankID = res.rankID;
            this.form.thName = res.thName;
            this.form.enName = res.enName;
            this.form.mobilePhone = res.mobilePhone;
            this.form.email = res.email;
            this.form.password = res.password;
            this.form.password_confirmation = res.password_confirmation;
            this.checkRole(res.isPresident, "isPresident");
            this.checkRole(res.isReviewer, "isReviewer");
            this.checkRole(res.isSecretary, "isSecretary");
            this.checkRole(res.isStaff, "isStaff");
            this.form.pictureFile = res.pictureFile;
            this.imageUrl = res.pictureFilePath;
            this.form.signatureImage = res.signatureImage;
            this.imageUrlSignature = res.signatureImagePath;
            this.updateData("scMastery", res.scMastery);
            this.updateData("scPosition", res.scPosition);
            this.updateData("scAffiliation", parseInt(res.scAffiliation));
            this.form.otherScMastery = res.otherScMastery;
            this.form.otherScPosition = res.otherScPosition;
            this.form.otherScAffiliation = res.otherScAffiliation;
            this.form.orderNumber = res.orderNumber;
            this.orderChangeDate = res.orderDate
                ? this.changeDate(res.orderDate)
                : "";
            this.form.orderDate = res.orderDate;
            if (res.sc_training.length > 0) {
              this.fixTraining = res.sc_training;
              res.sc_training.forEach((data, i) => {
                this.fixTraining[i].trainingDateShow = this.changeDate(
                    data.trainingDate
                );
                this.fixTraining[i].trainingDate = data.trainingDate;
              });
            }
            this.form.isScientist = res.isScientist
                ? res.isScientist.toString()
                : "";
            this.form.isAffiliated = res.isAffiliated
                ? res.isAffiliated.toString()
                : "";
            this.isLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.isLoading = false;
          });
    },
    save() {
      this.isLoading = true;
        this.$store
            .dispatch("Meeting/reviewSave", this.form)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                title: "Success",
                text: "บันทึกผลการประเมิน สำเร็จ",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$router.push("/sub-meeting");
              });
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
    },
    onUploadFile(val, e) {
        this.$store
            .dispatch("Common/onUploadFile", {name: val, file: e})
            .then((res) => {
              console.log("res", res);
              this.form.file = res.fileName;
            })
            .catch((error) => {
              console.log(error);
            });
    },
    onHandleBtn(name) {
      document.getElementById(name).click();
    },
    updateData(name, val) {
      this.form[name] = val;
    },
  },
};
</script>

<style scoped></style>
